// Kategori şemasına göre yalnızca DOLU olan imalat detaylarını salt-okunur gösterir.

function scalarEmpty(val) {
  if (val === null || val === undefined) return true;
  if (typeof val === "string" && val.trim() === "") return true;
  if (Array.isArray(val)) return val.length === 0;
  return false;
}

function fieldEmpty(field, val) {
  if (field.type === "boolean") return !val;
  if (field.type === "object") {
    const insts = Array.isArray(val) ? val : [];
    return insts.every((inst) => (field.fields || []).every((sf) => fieldEmpty(sf, (inst || {})[sf.key])));
  }
  return scalarEmpty(val);
}

// Bir field listesinde dolu değer var mı?
export function hasAnyValue(fields, value) {
  const v = value || {};
  return (fields || []).some((f) => !fieldEmpty(f, v[f.key]));
}

// Saf özyinelemeli render fonksiyonu — dolu satır elemanlarından oluşan bir dizi döner.
// (JSX'te kendi bileşen adını tag olarak KULLANMAZ; babel özyineleme sorununu önler.)
function renderRows(fields, value, prefix) {
  const v = value || {};
  return (fields || []).map((field) => {
    const val = v[field.key];
    if (fieldEmpty(field, val)) return null;
    const { type, label, key } = field;

    if (type === "object") {
      const insts = (Array.isArray(val) ? val : []).filter(
        (inst) => !(field.fields || []).every((sf) => fieldEmpty(sf, (inst || {})[sf.key]))
      );
      return (
        <div key={key} className="pt-1" data-testid={`${prefix}-${key}`}>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">{label}</div>
          <div className="space-y-1.5">
            {insts.map((inst, i) => (
              <div key={i} className="border border-zinc-200 rounded px-2.5 py-1.5 bg-white">
                <div className="text-[11px] font-medium text-zinc-400 mb-1">{label} #{i + 1}</div>
                <div className="space-y-2">{renderRows(field.fields, inst, `${prefix}-${key}-${i}`)}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    let display;
    if (type === "boolean") display = "Evet";
    else if (type === "multiselect") display = (Array.isArray(val) ? val : []).join(", ");
    else display = String(val);

    return (
      <div key={key} className="flex gap-2 text-sm" data-testid={`${prefix}-${key}`}>
        <span className="text-zinc-500 min-w-[130px] shrink-0">{label}</span>
        <span className="font-medium">{display}</span>
      </div>
    );
  }).filter(Boolean);
}

export default function DynamicDetailsView({ fields, value, testIdPrefix = "detail-view" }) {
  const rows = renderRows(fields, value, testIdPrefix);
  if (!rows || rows.length === 0) return null;
  return <div className="space-y-2" data-testid={testIdPrefix}>{rows}</div>;
}
